// extracted by css-extract-rspack-plugin
export default {"formFilter":"A6KGFgP1lI4iR0jH","filterWrapper":"PbZsuX7koJ4qgVxl","fieldWrapper":"mX5_l0c4vKoRBMe3","label":"LUO8J5mg2coxdXp5","buttons":"z9UizOGAWDEU6474"};